export const DEVICE_TYPE = {
	DESKTOP_CHROME: 'DESKTOP_CHROME',
	DESKTOP: 'DESKTOP',
	IOS: 'IOS',
	ANDROID: 'ANDROID',
	IPAD: 'IPAD',
	TABLET: 'TABLET',
};
